import { type CalendarEvent } from "@/types/portfolio"
import { triggerDownload } from "@/lib/api/hive"

function escapeCSV(value: string): string {
	if (value.includes(",") || value.includes('"') || value.includes("\n")) {
		return `"${value.replace(/"/g, '""')}"`
	}
	return value
}

export function exportCalendarEventsAsCSV(events: CalendarEvent[], filename: string): void {
	const header = "Payment Date,Ex-Date,Ticker,Exchange,Portfolio,Amount,Currency,Status"
	const rows = events.map((event) => {
		const paymentDate = event.payment_date ? new Date(event.payment_date).toISOString().split("T")[0] : ""
		const exDate =
			event.ex_date && event.ex_date !== "0001-01-01T00:00:00Z"
				? new Date(event.ex_date).toISOString().split("T")[0]
				: ""
		return [
			paymentDate,
			exDate,
			escapeCSV(event.ticker),
			escapeCSV(event.exchange),
			escapeCSV(event.portfolio_name),
			event.amount.toString(),
			event.currency || "",
			event.status,
		].join(",")
	})

	const csv = [header, ...rows].join("\n")
	const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" })
	triggerDownload(blob, filename)
}
